import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.canvas = this.$('canvas')[0];
        this.windowWidth = window.innerWidth;

        this.ctx = this.canvas.getContext('2d');
        this.color = (typeof this.getData('color') == 'string') ? this.getData('color') : '#E7BEAF';
        this.isReversed = typeof this.getData('reversed') == 'string';
    }

    init() {

        this.resize(true);
        this.bindResize = this.resize.bind(this);
        window.addEventListener('resize', this.bindResize);
        
        this.pullingPoint = {
            y: 0
        }

        if(!this.isReversed) {
            this.tl = gsap.fromTo(this.pullingPoint,{
                y: 1
            },{
                y: 0
            });
        } else {
            this.pullingPoint = {
                y: 1
            }
            this.tl = gsap.fromTo(this.pullingPoint,{
                y: 0
            },{
                y: 1
            });
        }
        this.tl.pause();

        this.draw();
    }

    trigger(e) {
        if(e.mode == 'enter') {
            this.draw();
        } else {
            cancelAnimationFrame(this.raf);
        }
    }

    progress({progress, isReversed}) {
        let relativeProgress = progress;
        if(isReversed) relativeProgress = 1-progress;
        
        if(this.tl != undefined) {
            this.tl.progress(relativeProgress);
        }
    }

    draw(frame = false) {

        if(!frame) {
            this.raf = requestAnimationFrame(() => this.draw());
        }
        
        this.ctx.clearRect(0,0,this.w, this.h);
        this.ctx.beginPath();
        this.ctx.moveTo(0,0);
        this.ctx.lineTo(0,this.pullingPoint.y * this.h);

        if(!this.isReversed) {
            this.ctx.quadraticCurveTo(this.w/2, (1 - this.pullingPoint.y) * this.h, this.w, this.pullingPoint.y * this.h);
        } else {
            this.ctx.bezierCurveTo(this.w/5, (1 - this.pullingPoint.y) * this.h, this.w*4/5, (1 - this.pullingPoint.y) * this.h, this.w, this.pullingPoint.y * this.h);
        }
        this.ctx.lineTo(this.w,0);
        this.ctx.fillStyle = this.color;
        this.ctx.fill();
        this.ctx.closePath();
    }

    resize(firstHit = false) {
        if(!window.isMobile || window.innerWidth != this.windowWidth || firstHit) {
            this.windowWidth = window.innerWidth;

            this.w = this.el.getBoundingClientRect().width;
            this.h = this.el.getBoundingClientRect().height;

            this.unit = (this.w < this.h) ? this.w * 1.2 : this.h * 1.5;

            this.canvas.width = this.w;
            this.canvas.height = this.h;
            this.canvas.style.width = `${this.w}px`;
            this.canvas.style.height = `${this.h}px`;


            
        }

    }

    destroy() {
        cancelAnimationFrame(this.raf);
    }
}
